import axiosInstance from '../utils/AxiosConfig';

export const REFERENCE_TYPE = {
  SUPPLY: 1,
  PREPARATION: 2,
  PRODUCT: 4
};

export const getStockHistory = async (locationId, referenceType, referenceId, page = 1, pageSize = 20) => {
  const params = new URLSearchParams({
    locationId: locationId.toString(),
    referenceType: referenceType.toString(),
    referenceId: referenceId.toString(),
    page: page.toString(),
    pageSize: pageSize.toString()
  });

  const response = await axiosInstance.get(`/stock/history?${params}`);
  return response.data.data;
};
